import { Link } from "react-router-dom";
import { allArticles } from "@/mocks/articles";

export default function ArticlesSection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold tracking-wide uppercase mb-4">
            Blog
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            Últimos Artigos
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            Guias completos e dicas exclusivas sobre Hoobuy Spreadsheet para você aproveitar ao máximo
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {allArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/artigo/${article.slug}`}
              className="group block rounded-xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-200 hover:shadow-md transition-all cursor-pointer"
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 mb-3">
                  <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium">
                    {article.category}
                  </span>
                  <span className="text-xs text-foreground-400">{article.readTime}</span>
                </div>
                <h3 className="font-heading text-sm md:text-base font-bold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-4">
                  {article.description}
                </p>
                <div className="flex items-center gap-2 text-xs text-primary-600 font-medium">
                  <span>Ler artigo</span>
                  <i className="ri-arrow-right-line w-3 h-3 flex items-center justify-center"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}